import { useState, useEffect, useContext } from "react";
import _ from "lodash";
import { Sockets } from "../constants/Sockets";
import { ConfigContext } from "../security/ConfigContext";
import { SocketContext } from "../context/SocketContext";
import { useOktaAuth } from '@okta/okta-react';

const useWebSocket = () => {
  const [socket, setSocket] = useState(null);
  const [config] = useContext(ConfigContext);
  const { oktaAuth } = useOktaAuth();

  const {
    messageToSocket,
    _setMessageFromSocket,
    _setMessageToSocket,
    _setWebsocketConnection
  } = useContext(SocketContext);

  useEffect(() => {
    // readyState value 1 is socket connection is open and ready to communicate.
    if (messageToSocket && socket?.readyState === 1) {
      socket.send(
        JSON.stringify({ action: "sendmessage", data: messageToSocket })
      );
      _setMessageToSocket("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageToSocket, socket?.readyState]);

  const setErrorMessage = (error, currentAttempt) => {
    currentAttempt++;
    if (currentAttempt < Sockets.retry) {
      const webSocketConnection = async () => {
        const ws = await connectSocket(currentAttempt);
        _setWebsocketConnection(ws);
      };
      webSocketConnection();
    }
    return currentAttempt;
  };

  const connectSocket = async (attempt = 0) => {
    let currentAttempt = attempt;
    const uri = config.app.wsApiURL;
    const objAccessToken = await oktaAuth.tokenManager.get("accessToken");
    const getAccessToken = objAccessToken?.accessToken;
    try {
      const ws = new WebSocket(uri, ["Token", getAccessToken]);
      ws.onerror = (error) => {
        currentAttempt = setErrorMessage(error, currentAttempt);
      };
      ws.onopen = () => {
        setSocket(ws);
        console.log("Connection Opened!");
        ws.onerror = (error) => {
          const message = _.get(error, "message");
          console.error(
            "Socket encountered error: ",
            message,
            "Closing socket"
          );
          ws.close();
        };
        ws.onmessage = (message) => {
          const messageFromTheSocket =  message ? JSON.parse(message['data']) : "";
          console.log('MESSAGE',messageFromTheSocket.message);
          _setMessageFromSocket(messageFromTheSocket.type);
        };
        ws.onclose = (e) => {
          if (e.code !== 1000) {
            console.log(
              "WebSocket is closed. Reconnect will be attempted in 1 second.",
              e.reason
            );
            setTimeout(async() => {
             const ws = await connectSocket();
             _setWebsocketConnection(ws)
            }, Sockets.closingTime);
          } else {
            console.log("WebSocket is closed");
          }
        };
      };
      return ws;
    } catch (error) {
      setErrorMessage(error, currentAttempt);
    }
  };

  return { connectSocket };
};

export default useWebSocket;
